import { CmdDevaluationPeriod } from "./CmdDevaluationPeriod";

export class CmdDevaluationProduct {
    model: string;
    modelTitle: string;
    periodData:Array<CmdDevaluationPeriod> = [];
    fiveYearAverage: string;
    average: string;
}